<form style="padding: 10px !important;">
    <div style="display: flex; justify-content: flex-end;">
        <mat-icon [mat-dialog-close]='false'>close</mat-icon>
    </div>
    <mat-icon
        style="display: flex; align-items: center; justify-content: center; padding-left: 50%; font-size: 32px !important; color: #00b0fa;">
        verified_user</mat-icon>
    <p style="display: flex; justify-content: center; padding-top: 5px;">Enter OTP</p>

    <div
        style="display: flex; align-items: center; justify-content: center; color: rgb(171 171 174); padding-bottom: 20px;">
        OTP is in customer's Order History :
    </div>

    <div style="display: flex; flex-direction: column; align-items: center; padding-bottom: 10px; height: 27%;">
        <div class="otp-container">
            <input type="number" id='first' (focus)="$event.target.select()" (keyup)="onEnterOtp($event, 'second', 0)"
                class="otp_input">
            <input type="number" id='second' (focus)="$event.target.select()" (keyup)="onEnterOtp($event, 'third', 1)"
                class="otp_input">
            <input type="number" id='third' (focus)="$event.target.select()" (keyup)="onEnterOtp($event, 'fourth', 2)"
                class="otp_input">
            <input type="number" id='fourth' (focus)="$event.target.select()" (keyup)="onEnterOtp($event,'fifth', 3)"
                class="otp_input">
            <input type="number" id='fifth' (focus)="$event.target.select()" (keyup)="onEnterOtp($event, 'sixth', 4)"
                class="otp_input">
            <input type="number" id='sixth' (focus)="$event.target.select()"
                (keyup)="onEnterOtp($event, 'submitBtn', 5)" class="otp_input">
        </div>
        <div *ngIf="showError" [ngClass]="{'shake': isShaking}" style="color: red; font-size: 14px;">
            <mat-icon style="top: 2px !important;">warning</mat-icon>Enter the valid OTP.
        </div>
        <div *ngIf="showSucess" style="color: green; font-size: 14px !important; width: 17px !important;">
            <mat-icon style="top: 2px !important;">done</mat-icon>Your OTP has been verified.
        </div>
    </div>

    <div style="display: flex; align-items: center; justify-content: center; flex-direction: column;">
        <button id="submitBtn" style="width: 75%; height: 10%; background-color: #00b0fa; border-radius: 5px;"
            [disabled]="buttonDisabled" [style.backgroundColor]="buttonDisabled ? '#aaa' : '#00b0fa'"
            (click)="submitClick()">
            Submit
        </button>
    </div>
</form>